import LazyLoadImageWithBlurHash from "./LazyLoadImageWithBlurHash";

export default LazyLoadImageWithBlurHash;
